import refreshToken from './refreshToken'
export default ({ graphQLErrors, networkError }, nuxtContext) => {
  if (graphQLErrors) {
      graphQLErrors.map(({ message, locations }) => console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}`))
    }
  if (networkError) {
    const message = networkError.message.split(': ')
    if (message[1] === 'Received status code 401') {
      console.log('go to refresh token')
      refreshToken(nuxtContext)
    }
    console.log(message[1])
  }
}
